import React from "react";

import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { FaMapMarkerAlt } from "react-icons/fa";

import { ContactData } from "../data-types/api-client/api-contacts";

interface ContactProps {
  contact: ContactData | undefined; // Accept ContactData as a prop
}

const containerStyle = {
  width: "100%",
  height: "400px",
};

const center = {
  lat: 49.346559,
  lng: 19.593495,
};

const GoogleMapComponent: React.FC<ContactProps> = ({ contact }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  if (!apiKey) {
    throw new Error("Chýba Google API kľúč v .env");
  }

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: apiKey ?? "",
  });

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col items-center w-full p-2 bg-gray-100 gap-4 rounded-lg">
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15}>
        <Marker position={center} />
      </GoogleMap>
      <button
        className="bg-custom-blue border border-custom-blue/10 hover:bg-custom-blue-600 gap-3 rounded-lg py-2 px-4 flex items-center justify-center hover:cursor-pointer transition duration-200 ease-in-out"
        onClick={() =>
          window.open(
            `${contact?.contact.address.dispensingPointGoogleMapsUrl}`,
            "_blank",
          )
        }
      >
        <div className="flex justify-end rounded-full p-2 bg-custom-white">
          <FaMapMarkerAlt className="w-5 h-auto md:w-5 md:h-5 text-custom-blue-600" />
        </div>{" "}
        <div className="flex flex-col justify-center items-center">
          <span className="text-base font-semibold tracking-wider text-custom-white">
            Otvoriť v mapách
          </span>
        </div>
      </button>
    </div>
  );
};

export default GoogleMapComponent;
